import { authAxios } from "../../config/axiosConfig";

async function deleteCurrentCustomer() {
    return await authAxios.delete(`/customer`)
}
export const customerApi = {
    deleteCurrentCustomer
}

